import { Component, OnInit } from '@angular/core';
import { Lang } from 'src/app/Constants/app.model';
import { DataService } from 'src/app/data.service';

declare var Genesys: any; // <-- allow use of global Genesys object

@Component({
  selector: 'app-pregnant-parenting',
  templateUrl: './pregnant-parenting.component.html',
  styleUrls: ['./pregnant-parenting.component.scss']
})
export class PregnantParentingComponent implements OnInit {
  title: string;
  content: string;
  currentLang: Lang = 'en';
  currentRouteMap: any;
  constructor(private services: DataService) {
    this.services.selectedLang.subscribe(lang => {
      this.currentLang = lang;
    });
    this.services.currentRouteMap.subscribe(routeMap => {
      this.currentRouteMap = routeMap;
    });
  }

  ngOnInit(): void {
    this.services.getPregnentParenting().subscribe(res => {
      if (res) {
        this.title = res.title.rendered;
        this.content = res.content.rendered;
      }
      // for(var j=0; j<=data.length-1;j++)
      // {
      //     if(data[j].id!='31')
      //         continue;
      //      if(data[j].id=='31')
      //      {
      //         var ineedhelptitle = data[j].title.rendered;
      //         var ineedhelpcontent =  data[j].content.rendered;
      //         $('#ineedhelp-title').html(ineedhelptitle);
      //         $('#ineedhelp-content').html(ineedhelpcontent);
      //         var contnt=$('#ineedhelp-content p').eq(0).text();
      //          $('#ineedhelp-content p').eq(0).html('<h3 class="vt-m mt-3">'+contnt+'</h3>');
      //      }
      // }
    });
  }

  openMessenger() {
    try {
      Genesys('subscribe', 'Messenger.ready', () => {
        Genesys(
          'command',
          'Messenger.open',
          {},
          () => {
            console.log('Messenger opened');
          },
          (error: any) => {
            console.error("Couldn't open messenger.", error);
          }
        );
      });
    } catch (err) {
      console.error('Genesys Messenger is not initialized yet.', err);
    }
  }
}
